<template>
  <div role="list">
    <div @click="backButtonLevel1()">
      <slot name="backbutton">back button</slot>
    </div>
    <slot name="megamenucontainer">megamenu container</slot>
  </div>
</template>

<script>
export default {
  name: 'megamenu',
  data() {
    return {
      active: false,
    };
  },
  methods: {
    backButtonLevel1() {
      if (window.eventBus) {
        window.eventBus.$emit('update.itemnavigation', false);
      }
    },
  },
};
</script>
